import Vue from "vue";
import Router from "vue-router";
import store from "@/store/index";
// https://github.com/declandewet/vue-meta
import VueMeta from "vue-meta";

// Adds a loading bar at the top during page loads.
import NProgress from "nprogress/nprogress";

// components
// const TheContainer = () => import("@/components/TheContainer");

// Views - Student
const StudentDashboard = () => import("@/views/users/student/StudentDashboard");
const Student = () => import("@/views/users/student/Student");
const StudentClasses = () => import("@/views/users/student/StudentClasses");
const studentCourse = () =>
  import("@/views/users/student/course/studentCourse");
// student ticket
const studentTicket = () =>
  import("@/views/users/student/ticket/studentTicket");
//manger poll
const studentPoll = () => import("@/views/users/student/poll/studentPoll");
// Views - Teacher
const Teacher = () => import("@/views/users/teacher/Teacher");
const TeacherDashboard = () => import("@/views/users/teacher/TeacherDashboard");
const TeacherClass = () => import("@/views/users/teacher/TeacherClasses");
const TeacherCourse = () =>
  import("@/views/users/teacher/course/TeacherCourse");
const TeacherHomeworkAnswer = () =>
  import("@/views/users/teacher/course/TeacherHomeworkAnswer");

// teacher ticket
const teacherTicket = () =>
  import("@/views/users/teacher/ticket/teacherTicket");
// Views - Manager
const Manager = () => import("@/views/users/manager/Manager");
const ManagerDashboard = () => import("@/views/users/manager/ManagerDashboard");
const ManageStudent = () =>
  import("@/views/users/manager/student/ManageStudent");
const ManageStaff = () => import("@/views/users/manager/staff/ManageStaff");
const ManagerCourseList = () =>
  import("@/views/users/manager/course/ManagerCourseList");
const ManagerCourse = () =>
  import("@/views/users/manager/course/ManagerCourse");
const ManagerHomeworkAnswer = () =>
  import("@/views/users/manager/course/ManagerHomeworkAnswer");

// manager ticket
const managerTicket = () =>
  import("@/views/users/manager/ticket/managerTicket");
//manger poll
const managerPoll = () => import("@/views/users/manager/poll/managerPoll");
const managerPollDetails = () =>
  import("@/views/users/manager/poll/managerPollDetails");
const addPollQuestionPage = () =>
  import("@/views/users/manager/poll/addPollQuestionPage");
const editPollQuestionPage = () =>
  import("@/views/users/manager/poll/editPollQuestionPage");

// manager Report
const managerReport = () =>
  import("@/views/users/manager/report/managerReport");
//student status
const managerStudentStatus = () =>
  import("@/views/users/manager/student/managerStudentStatus");
const studentStatus = () => import("@/views/users/student/studentStatus");

//views - news
const newsPage = () => import("@/views/pages/newsPage/newsPage");
const news = () => import("@/views/pages/newsPage/news");

//views - exams
const studentOnlineExams = () =>
  import("@/views/users/student/studentExam/studentOnlineExams.vue");
const addExam = () => import("@/views/pages/exam/addExamPage.vue");
const showExam = () =>
  import("@/views/users/student/studentExam/showExamPage.vue");
const teacherOnlineExams = () =>
  import("@/views/users/teacher/teacherExam/teacherOnlineExams.vue");
const teacherOfflineExams = () =>
  import("@/views/users/teacher/teacherExam/teacherOfflineExams.vue");
const managerOnlineExams = () =>
  import("@/views/users/manager/managerExam/managerOnlineExams.vue");
const managerOfflineExams = () =>
  import("@/views/users/manager/managerExam/managerOfflineExams.vue");
const addStudentMarkTable = () =>
  import("@/views/pages/exam/addStudentMarkTable.vue");

// Views - Auth
const Login = () => import("@/views/auth/Login");
const ForgetPass = () => import("@/views/auth/ForgetPass");
const ChangePass = () => import("@/views/auth/ChangePass");
// const Register = () => import("@/views/auth/Register");

//Question Bank
const adminQuestionBank = () =>
  import("@/views/pages/questionBank/adminQuestionBank.vue");
const studentQuestionBank = () =>
  import("@/views/pages/questionBank/studentQuestionBank.vue");

Vue.use(Router);
Vue.use(VueMeta, {
  // The component option name that vue-meta looks for meta info on.
  keyName: "page",
});

const router = new Router({
  mode: "history", // https://router.vuejs.org/api/#mode
  linkActiveClass: "active",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: configRoutes(),
});

function configRoutes() {
  return [
    {
      path: "/student",
      redirect: "/student/dashboard",
      name: "Student",
      meta: {
        label: "خانه",
        beforeResolve(routeTo, routeFrom, next) {
          // If the user is already logged in
          if ("STUDENT" === store.getters["userType"]) {
            next();
          } else {
            next({ path: "auth" });
          }
        },
      },
      component: Student,
      children: [
        {
          path: "dashboard",
          name: "داشبورد",
          component: StudentDashboard,
        },
        {
          path: "classes",
          name: "کلاس ها",
          component: StudentClasses,
        },
        {
          path: "course/:id",
          name: "دروس",
          component: studentCourse,
        },
        {
          path: "news",
          name: "اخبار",
          component: newsPage,
        },
        {
          path: "news/:id",
          name: "خبر",
          component: news,
        },
        {
          path: "exam",
          name: "آزمون آنلاین",
          component: studentOnlineExams,
        },
        {
          path: "exam/:id",
          name: "آزمون",
          component: showExam,
        },
        {
          path: "bank",
          name: "بانک سوالات",
          component: studentQuestionBank,
        },
        {
          path: "ticket",
          name: "تیکت",
          component: studentTicket,
        },
        {
          path: "poll",
          name: "نظرسنجی",
          component: studentPoll,
        },
        {
          path: ":id",
          name: "دانش اموز",
          component: studentStatus,
        },
        {
          path: "student",
          redirect: "/student/:id",
          name: "دانش اموز",
        },
      ],
    },
    {
      path: "/manager",
      redirect: "/manager/dashboard",
      name: "Manager",
      meta: {
        label: "خانه",
        beforeResolve(routeTo, routeFrom, next) {
          if ("MANAGER" === store.getters["userType"]) {
            next();
          } else {
            next({ path: "auth" });
          }
        },
      },
      component: Manager,
      children: [
        {
          path: "dashboard",
          name: "داشبورد",
          component: ManagerDashboard,
        },
        {
          path: "student",
          name: "دانش‌آموزان",
          component: ManageStudent,
        },
        {
          path: "student/:id",
          name: "دانش‌آموزان",
          component: managerStudentStatus,
        },
        {
          path: "staff",
          name: "کادر آموزشی",
          component: ManageStaff,
        },
        {
          path: "course",
          name: "محتوای آموزشی",
          component: ManagerCourseList,
        },
        {
          path: "course/:id",
          name: "دروس",
          component: ManagerCourse,
        },
        {
          path: "homework/:id",
          name: "تکلیف",
          component: ManagerHomeworkAnswer,
        },
        {
          path: "news",
          name: "اخبار",
          component: newsPage,
        },
        {
          path: "news/:id",
          name: "خبر",
          component: news,
        },
        {
          path: "exam",
          name: "آزمون آنلاین",
          component: managerOnlineExams,
        },
        {
          path: "exam/:id",
          name: "آزمون آنلاین",
          component: addExam,
        },
        {
          path: "exam/:id/:studentId",
          name: "آزمون آنلاین",
          component: addStudentMarkTable,
          props: true,
        },
        {
          path: "offexam",
          name: "ارزشیابی",
          component: managerOfflineExams,
        },
        {
          path: "offexam/:id",
          name: "ارزشیابی",
          component: addExam,
        },
        {
          path: "bank",
          name: "بانک سوالات",
          component: adminQuestionBank,
        },
        {
          path: "ticket",
          name: "تیکت",
          component: managerTicket,
        },
        {
          path: "poll",
          name: "نظرسنجی",
          component: managerPoll,
        },
        {
          path: "poll/:id",
          name: "نظرسنجی",
          component: managerPollDetails,
        },
        {
          path: "poll/:id/addQuestion",
          name: "افزودن سوال",
          component: addPollQuestionPage,
        },
        {
          path: "poll/:id/:qId",
          name: "ویرایش سوال",
          component: editPollQuestionPage,
        },
        {
          path: "report",
          name: "گزارش ها",
          component: managerReport,
        },
      ],
    },
    {
      path: "/teacher",
      redirect: "/teacher/dashboard",
      meta: {
        label: "خانه",
        beforeResolve(routeTo, routeFrom, next) {
          if ("TEACHER" === store.getters["userType"]) {
            next();
          } else {
            next({ path: "auth" });
          }
        },
      },
      component: Teacher,
      children: [
        {
          path: "dashboard",
          name: "داشبورد",
          component: TeacherDashboard,
        },
        {
          path: "classes",
          name: "کلاس ها",
          component: TeacherClass,
        },
        {
          path: "course/:id",
          name: "دروس",
          component: TeacherCourse,
        },
        {
          path: "homework/:id",
          name: "تکلیف",
          component: TeacherHomeworkAnswer,
        },
        {
          path: "news",
          name: "اخبار",
          component: newsPage,
        },
        {
          path: "news/:id",
          name: "خبر",
          component: news,
        },
        {
          path: "exam",
          name: "آزمون آنلاین",
          component: teacherOnlineExams,
        },
        {
          path: "exam/:id",
          name: "آزمون آنلاین",
          component: addExam,
        },
        {
          path: "offexam",
          name: "ارزشیابی",
          component: teacherOfflineExams,
        },
        {
          path: "offexam/:id",
          name: "ارزشیابی",
          component: addExam,
        },
        {
          path: "exam/:id/:studentId",
          name: "آزمون آنلاین",
          component: addStudentMarkTable,
          props: true,
        },
        {
          path: "bank",
          name: "بانک سوالات",
          component: adminQuestionBank,
        },
        {
          path: "ticket",
          name: "تیکت",
          component: teacherTicket,
        },
      ],
    },
    {
      path: "/auth",
      redirect: "/auth/login",
      name: "auth",

      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "login",
          name: "login",
          component: Login,
          meta: {
            beforeResolve(routeTo, routeFrom, next) {
              if ("STUDENT" === store.getters["userType"]) {
                next({ path: "student" });
              } else if ("TEACHER" === store.getters["userType"]) {
                next({ path: "teacher" });
              } else if ("MANAGER" === store.getters["userType"]) {
                next({ path: "manager" });
              } else {
                next();
              }
            },
          },
        },
        {
          path: "forgrt-password",
          name: "ForgetPass",
          component: ForgetPass,
          meta: {
            beforeResolve(routeTo, routeFrom, next) {
              if ("STUDENT" === store.getters["userType"]) {
                next({ path: "student" });
              } else if ("TEACHER" === store.getters["userType"]) {
                next({ path: "teacher" });
              } else if ("MANAGER" === store.getters["userType"]) {
                next({ path: "manager" });
              } else {
                next();
              }
            },
          },
        },
        {
          path: "change-password",
          name: "ChangePass",
          component: ChangePass,
        },
      ],
    },
    {
      path: "*",
      redirect: "/auth",
    },
  ];
}

// Before each route evaluates...
router.beforeEach((routeTo, routeFrom, next) => {
  // If this isn't an initial page load...
  if (routeFrom.name !== null) {
    // Start the route progress bar.
    NProgress.start();
  }

  // Check if auth is required on this route
  // (including nested routes).
  const authRequired = routeTo.matched.some((route) => route.meta.authRequired);

  // If auth isn't required for the route, just continue.
  if (!authRequired) return next();

  // If auth is required and the user is logged in...

  if (store.getters["loggedIn"]) {
    // Validate the local user token...
    return next();
    // return store.dispatch('auth/validate').then((validUser) => {
    //   // Then continue if the token still represents a valid user,
    //   // otherwise redirect to login.
    //   validUser ? next() : redirectToLogin()
    // })
  }

  // If auth is required and the user is NOT currently logged in,
  // redirect to login.
  redirectToLogin();

  function redirectToLogin() {
    // Pass the original route to the login component
    next({ name: "login", query: { redirectFrom: routeTo.fullPath } });
  }
});

router.beforeResolve(async (routeTo, routeFrom, next) => {
  // Create a `beforeResolve` hook, which fires whenever
  // `beforeRouteEnter` and `beforeRouteUpdate` would. This
  // allows us to ensure data is fetched even when params change,
  // but the resolved route does not. We put it in `meta` to
  // indicate that it's a hook we created, rather than part of
  // Vue Router (yet?).
  try {
    // For each matched route...
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        // If a `beforeResolve` hook is defined, call it with
        // the same arguments as the `beforeEnter` hook.
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            // If the user chose to redirect...
            if (args.length) {
              // If redirecting to the same route we're coming from...
              if (routeFrom.name === args[0].name) {
                // Complete the animation of the route progress bar.
                NProgress.done();
              }
              // Complete the redirect.
              next(...args);
              reject(new Error("Redirected"));
            } else {
              resolve();
            }
          });
        } else {
          // Otherwise, continue resolving the route.
          resolve();
        }
      });
    }
    // If a `beforeResolve` hook chose to redirect, just return.
  } catch (error) {
    return;
  }

  // If we reach this point, continue resolving the route.
  next();
});

// When each route is finished evaluating...
router.afterEach((routeTo, routeFrom) => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});

export default router;